// Skills Section Data
// Edit this file to update skills and proficiency levels
// Level is a number from 0-100 representing skill proficiency
// logo: Path to logo image in /logos folder (e.g., "aws.png")
// Only skills with logos in the /logos folder are included

export const skillsData = {
  heading: "Skills",
  description: "Technical skills and expertise in cloud platforms, DevOps tools, and infrastructure automation",
  categories: [
    {
      category: "Technical Skills",
      skills: [
        { name: "Amazon Web Services (AWS)", level: 95, logo: "aws.png" },
        { name: "Microsoft Azure", level: 90, logo: "azure.png" },
        { name: "Terraform", level: 95, logo: "terraform.png" },
        { name: "Git", level: 95, logo: "git.png" },
        { name: "GitLab CI", level: 90, logo: "gitlab.png" },
        { name: "GitHub Actions", level: 90, logo: "github.png" },
        { name: "Azure DevOps", level: 85, logo: "azure-devops.png" },
        { name: "Docker", level: 95, logo: "docker.png" },
        { name: "Kubernetes", level: 90, logo: "kubernetes.png" },
        { name: "Python", level: 90, logo: "python.png" },
        { name: "Bash/Shell", level: 90, logo: "bash.png" },
        { name: "PowerShell", level: 75, logo: "powershell.png" },
        { name: "Ansible", level: 90, logo: "ansible.png" },
        { name: "Jenkins", level: 90, logo: "jenkins.png" },
        { name: "JavaScript/Node.js", level: 80, logo: "nodejs.png" },
        { name: "Linux Administration", level: 95, logo: "linux.png" },
        { name: "Google Cloud Platform (GCP)", level: 85, logo: "gcp.png" }
      ]
    }
  ]
};

